// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalDelete_header__OQmsr","description":"ModalDelete_description__JHpAt"};